import lang from "./translator";

const map = {
	'trans': 'get',
	'trans_choice': 'choice'
};

export default function (Vue) {
	for (let [filterName, methodName] of Object.entries(map)) {
		Vue.filter(filterName, (...args) => {
			return lang[methodName](...args);
		});
	}
}


// WEBPACK FOOTER //
// ./src/lang/filters.js